import CityPageTemplate from "../city-template/CityPageTemplate";
import { newcastleDeConfig } from "./data";

export default function NewcastleDePage() {
  return <CityPageTemplate config={newcastleDeConfig} />;
}